import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=36c872ea&scoped=true"
import script from "./BlogArticle.vue?vue&type=script&lang=js"
export * from "./BlogArticle.vue?vue&type=script&lang=js"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=36c872ea&prod&lang=scss&scoped=true"
import style1 from "./BlogArticle.vue?vue&type=style&index=1&id=36c872ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c872ea",
  null
  
)

export default component.exports